import { render, staticRenderFns } from "./cspecs.vue?vue&type=template&id=0fc49d27&scoped=true&"
import script from "./cspecs.vue?vue&type=script&lang=js&"
export * from "./cspecs.vue?vue&type=script&lang=js&"
import style0 from "./cspecs.vue?vue&type=style&index=0&id=0fc49d27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc49d27",
  null
  
)

export default component.exports